import { Navigate, useNavigate } from 'react-router-dom';
import { ShieldAlert, LogOut } from 'lucide-react';
import { useAuthStore } from '@/stores/authStore';
import { ROUTES } from '@/constants/routes';
import { Button } from '@/components/ui/button';
import { ChangePasswordCard } from '@/features/settings/components/ChangePasswordCard';
import { useLogout } from '@/features/auth/hooks/useLogin';

export function ForcePasswordChangePage() {
  const navigate = useNavigate();
  const { user, setUser, isAuthenticated } = useAuthStore();
  const { mutate: logout } = useLogout();

  if (!isAuthenticated) return <Navigate to={ROUTES.LOGIN} replace />;

  // Already changed (or a normal admin landing here directly) → go to dashboard.
  if (user && !user.must_change_password) return <Navigate to={ROUTES.DASHBOARD} replace />;

  const handleChanged = () => {
    if (user) setUser({ ...user, must_change_password: false });
    navigate(ROUTES.DASHBOARD, { replace: true });
  };

  return (
    <div className="min-h-screen bg-muted/30 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md space-y-6">
        <div className="text-center space-y-2">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-amber-100">
            <ShieldAlert className="h-6 w-6 text-amber-600" />
          </div>
          <h1 className="text-xl font-bold">Set a new password</h1>
          <p className="text-sm text-muted-foreground">
            Your account uses a temporary password. Please choose a new one to continue.
          </p>
        </div>

        <ChangePasswordCard forced onChanged={handleChanged} />

        <div className="text-center">
          <Button variant="ghost" size="sm" onClick={() => logout()}>
            <LogOut className="h-4 w-4 mr-2" /> Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
